import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/cues/post.ts
var post_exports = /* @__PURE__ */ __exportAll({ RequestSchema: () => RequestSchema });
var RequestSchema = z.object({
	name: z.string(),
	position: z.string(),
	privateCue: z.boolean(),
	user: z.string()
});
//#endregion
export { post_exports };

//# sourceMappingURL=post.js.map